module.exports = __webpack_public_path__ + "static/media/Jawbreak-Sans.2ba8335c.woff";